import { RootState } from "../store";

export const pizzaDataSelector = (state: RootState) => state.pizza;
